"use strict"; // tslint:disable member-ordering

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AbstractVideoEmbedder =
/*#__PURE__*/
function () {
  function AbstractVideoEmbedder() {
    _classCallCheck(this, AbstractVideoEmbedder);
  }

  _createClass(AbstractVideoEmbedder, null, [{
    key: "getEmbedMarker",
    value: function getEmbedMarker(id, type) {
      return "~~~ embed:".concat(id, " ").concat(type, " ~~~");
    }
  }, {
    key: "insertAllEmbeds",
    value: function insertAllEmbeds(embedders, input, size) {
      // In addition to inserting the youtube component, this allows
      // react to compare separately preventing excessive re-rendering.
      var idx = 0;
      var sections = []; // HtmlReady inserts ~~~ embed:${id} type ~~~

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = input.split("~~~ embed:")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var section = _step.value;
          var match = section.match(/^([A-Za-z0-9\?\=\_\-]+) ([^ ]*) ~~~/);

          if (match && match.length >= 3) {
            var id = match[1];
            var type = match[2];
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = embedders[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var embedder = _step2.value;
                var resp = embedder.processEmbedIfRelevant(type, id, size, idx++ + "");

                if (resp) {
                  sections.push(resp);
                  break;
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            section = section.substring("".concat(id, " ").concat(type, " ~~~").length); // section = section.substring(`${id} ${type} ~~~`.length);

            if (section === "") {
              continue;
            }
          }

          sections.push(section);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return sections.join("");
    }
  }]);

  return AbstractVideoEmbedder;
}();

exports.AbstractVideoEmbedder = AbstractVideoEmbedder;